import { UsuarioEscenario } from 'src/app/models/SicarMap/Escenario/UsuarioEscenario.model';
import * as fromAddScene from '../../../actions/AdmMapa/Escenarios/AddScene.actions';


export interface AddSceneState {
  Ejecutando: boolean;
  resultado: number | undefined;
  errorMessage: any | undefined;
}

export const initialState: AddSceneState = {
    Ejecutando: false,
    resultado: undefined,
    errorMessage: undefined
  };

export function AddSceneReducer(state = initialState, action: fromAddScene.AddSceneAcciones): AddSceneState {
    switch (action.type) {
      case fromAddScene.AddSceneTypes.SCENE_ADD: {
        return {
        ...state,
        Ejecutando: true,
        resultado: undefined,
        errorMessage: undefined
        };
      }
      case fromAddScene.AddSceneTypes.SCENE_ADD_SUCCESS: {
        return {
          ...state,
          Ejecutando: false,
          resultado: action.claveRS,
          errorMessage: undefined
        };
      }
      case fromAddScene.AddSceneTypes.SCENE_ADD_FAILURE: {
        return {
          ...state,
          Ejecutando: false,
          resultado: undefined,
          errorMessage: {...action.payload.error}
        };
      }
      case fromAddScene.AddSceneTypes.SCENE_ADD_RESET: {
        return {
          ...state,
          Ejecutando: false,
          resultado: undefined,
          errorMessage: undefined
        };
      }
      default: {
        return state;
      }
    }
}